export default __webpack_public_path__ + "static/media/Shot_3.0000.d4e9f4b0.png";